import React from "react";
import { BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";
import { toggle } from "../../../../util/common";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const TradePaymentData: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div className="link-item">
                {props.showAsAccordion ? (
                    <button
                        type="button"
                        aria-expanded="false"
                        className="link-button"
                        id="btn-payment-data"
                        onClick={(e) => toggle("payment-data-div", "btn-payment-data")}
                    >
                        <span className="row link-item">
                            <span className="col-xs col-no-gutter link-text">
                                <span className="link-title">
                                    <span className="btn-toggle-status sr-only">Show</span> Payment Data
                                </span>
                            </span>
                        </span>
                    </button>
                ) : (
                    <h5 className="report-sub-title">Payment Data</h5>
                )}

                <div className="wallet-details" id="payment-data-div" style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }} aria-hidden="true">
                    <div role="grid" className="data-grid row-height-xs " aria-labelledby="payment-data-div">
                        <div role="row" className="data-row condensed row">
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-dbt">
                                    Dbt
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-active-lines">
                                    Active Trade Lines
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-current">
                                    Current
                                </div>
                            </div>
                        </div>

                        <div role="row" className="data-row condensed row">
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" id="payment-data-dbt">
                                    {props.reportObject?.businessCompanyReport?.trade_payment_data?.dbt}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" aria-labelledby="payment-data-active-lines">
                                    {props.reportObject?.businessCompanyReport?.trade_payment_data?.trade_lines}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" aria-labelledby="payment-data-current">
                                    {props.reportObject?.businessCompanyReport?.trade_payment_data?.current}
                                </div>
                            </div>
                        </div>

                        <div role="row" className="data-row condensed row">
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-1-30">
                                    1-30
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-31-60">
                                    31-60
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-61-90">
                                    61-90
                                </div>
                            </div>
                        </div>

                        <div role="row" className="data-row condensed row">
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" id="payment-data-1-30">
                                    {props.reportObject?.businessCompanyReport?.trade_payment_data?.value_1_30}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" aria-labelledby="payment-data-31-60">
                                    {props.reportObject?.businessCompanyReport?.trade_payment_data?.value_31_60}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" aria-labelledby="payment-data-61-90">
                                    {props.reportObject?.businessCompanyReport?.trade_payment_data?.value_61_90}
                                </div>
                            </div>
                        </div>

                        <div role="row" className="data-row condensed row">
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-91-plus">
                                    91+
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-total-active-balance">
                                    Total Active Balances
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="payment-data-blank"></div>
                            </div>
                        </div>

                        <div role="row" className="data-row condensed row">
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" id="payment-data-91-plus">
                                    {props.reportObject?.businessCompanyReport?.trade_payment_data?.value_91_plus}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" aria-labelledby="payment-data-total-active-balance">
                                    {props.reportObject?.businessCompanyReport?.trade_payment_data?.total}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" aria-labelledby="payment-data-blank"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TradePaymentData;
